<template>
  <div
    class="px-1 h-full"
    :class="{'d-flex ': !VISAO_VERTICAL_ATIVA}"
  >
    <div :class="{'w-50-per pr-1 mt-n7': !VISAO_VERTICAL_ATIVA}">
      <TabelaDetalhesCategoria :count_atualizar_detalhes_categoria="count_atualizar_detalhes_categoria" />
    </div>

    <div
      :class="{
        'border-top-gray': VISAO_VERTICAL_ATIVA,
        'w-50-per border-left-gray': !VISAO_VERTICAL_ATIVA
      }"
      :style="{height: VISAO_VERTICAL_ATIVA ? 'calc(100vh - 446px)' : '275px'}"
    >
      <GraficoDetalhescategoria :count_atualizar_detalhes_categoria="count_atualizar_detalhes_categoria" />
    </div>
  </div>
</template>

<script>
import TabelaDetalhesCategoria from "./Tabela/Index.vue";
import GraficoDetalhescategoria from './Grafico/Index.vue';
import {categoria_selecionada} from "@/components/compra/materiaPrima/compra/Helpers/CategoriaSelecionado";

export default {
  name: "Index",
  mixins: [categoria_selecionada],
  components: {
    TabelaDetalhesCategoria,
    GraficoDetalhescategoria
  },
  computed: {
    GRUPO_COMPRA() {
      return this.$store.getters['usuario/getGrupoCompras'];
    },
    VISAO_VERTICAL_ATIVA() {
      return this.$store.getters['CompraProdutosGerais/getVisaoVertical'];
    }
  },
  watch: {
    GRUPO_COMPRA() {
      this.categoria_selecionada = null;
    }
  },
  data: () => ({
    count_atualizar_detalhes_categoria: 0
  }),
  mounted() {
    // essa funcao serve para atualizar o detalhes da categorias de qualquer lugar
    this.$store.dispatch("compraMateriaPrima/callbackAtualizarDetalhesCategoria", this.atualizarDetalhesCategoria);
  },
  methods: {
    atualizarDetalhesCategoria() {
      if (this.categoria_selecionada) {
        this.count_atualizar_detalhes_categoria += 1;
      }
    }
  }
}
</script>

<style scoped>
.w-50-per {
  width: 50%;
}
.border-top-gray {
  border-top: 1px solid #ece7e7;
}
.border-left-gray {
  border-left: 1px solid #ece7e7;
}
</style>
